import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { FaRegCalendarAlt, FaExternalLinkAlt } from "react-icons/fa";
import { FaFilePdf } from "react-icons/fa6";


import "./Novice.css";

// downloadPdf.js
export const downloadPdf = async (url, filename) => {
    try {
        // fetch PDF datoteke
        const response = await fetch(url);
        if (!response.ok) throw new Error("Napaka pri prenosu PDF.");

        // pretvori v Blob
        const blob = await response.blob();

        // ustvari temporarni link
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename || "datoteka.pdf";

        // klikni link za prenos
        document.body.appendChild(link);
        link.click();

        // odstrani link
        document.body.removeChild(link);
    } catch (err) {
        console.error("Napaka pri prenosu PDF:", err);
        alert("Napaka pri prenosu PDF.");
    }
};


const StranNovice = () => {
    const { id } = useParams();
    const [novica, setNovica] = useState(null);

    useEffect(() => {
        const fetchNovica = async () => {
            try {
                const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/novice/${id}`);
                const data = await res.json();
                setNovica(data);
            } catch (err) {
                console.error("Napaka pri pridobivanju novice:", err);
            }
        };
        fetchNovica();
    }, [id]);

    const formatirajDatum = (datum) => {
        if (!datum) return "";
        const meseci = [
            "januar", "februar", "marec", "april", "maj", "junij",
            "julij", "avgust", "september", "oktober", "november", "december"
        ];
        const date = new Date(datum);
        return `${date.getDate()}. ${meseci[date.getMonth()]} ob ${date.getHours().toString().padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}`;
    };

    const formatirajDatumm = (datum) => {
        if (!datum) return "";
        const meseci = [
            "januarja", "februarja", "marca", "aprila", "maja", "junija",
            "julija", "avgusta", "septembera", "oktobra", "novembera", "decembera"
        ];
        const date = new Date(datum);
        return `${date.getDate()}. ${meseci[date.getMonth()]}`;
    };


    if (!novica) return <p className="center">Nalaganje...</p>;

    return (
        <div className="stran-novice-wrapper">
            <div className="stran-novice-content center wdt">
                <div className="leva-stran">
                    <Link to="/novice" className="gumb-nazaj-aan margin-mal">
                        <IoIosArrowBack /> Nazaj na novice
                    </Link>

                    {novica.datum && (
                        <p className="datum-novice">
                            objavljeno:
                            {formatirajDatumm(novica.datum)}
                        </p>
                    )}
                    <h1 className="nomartop">{novica.ime}</h1>
                    <h3>{novica.podnaslov}</h3>


                    {novica.slike && novica.slike.length > 0 && (
                        <div className="slika-novica-flexk center">
                            {/*  prikaži samo prvo sliko kot glavno */}
                            <img
                                src={novica.slike[0]}
                                alt={`${novica.ime} - glavna slika`}
                                className="stran-novice-slika"
                            />
                        </div>
                    )}



                </div>
            </div>






            <div className="novica-spodajlala center wdt">
                <div className="novica-spodaj-content">
                    {novica.sekcije?.length > 0 ? (
                        novica.sekcije.map((sekcija, idx) => (
                            <div key={idx} className="novica-sekcija">
                                {sekcija.podnaslov && <h2>{sekcija.podnaslov}</h2>}

                                {/* Glavna vsebina sekcije (odstavki, slike, pdfji, linki) */}
                                {(() => {
                                    const elementi = [];
                                    for (let i = 0; i < sekcija.vsebina.length; i++) {
                                        const item = sekcija.vsebina[i];

                                        // ODSTAVEK + SLIKA (v paru)
                                        if (item.tip === "odstavek") {
                                            const naslednji = sekcija.vsebina[i + 1];
                                            const imaSliko = naslednji && naslednji.tip === "slika" && naslednji.url;
                                            const obrnjeno = (elementi.length / 2) % 2 === 1;

                                            if (imaSliko) {
                                                elementi.push(
                                                    <div
                                                        key={`odstavek-slika-${i}`}
                                                        className={`odstavek-s-slika ${obrnjeno ? "reverse" : ""}`}
                                                    >
                                                        <div className="odstavek-besedilo">
                                                            <p>{item.vsebina}</p>
                                                        </div>
                                                        <div className="odstavek-slika-wrapper">
                                                            <img
                                                                src={naslednji.url}
                                                                alt="Slika ob odstavku"
                                                                className="odstavek-slika"
                                                            />
                                                        </div>
                                                    </div>
                                                );
                                                i++; // preskoči sliko, ker je že prikazana
                                            } else {
                                                elementi.push(
                                                    <p key={i} className="odstavek-sekcije">{item.vsebina}</p>
                                                );
                                            }
                                            continue;
                                        }

                                        // POSAMEZNA SLIKA (če ni ob odstavku)
                                        if (item.tip === "slika" && item.url) {
                                            elementi.push(
                                                <div key={i} className="sekcija-slika-wrapper center">
                                                    <img
                                                        src={item.url}
                                                        alt={`Slika ${i + 1}`}
                                                        className="sekcija-slika"
                                                    />
                                                </div>
                                            );
                                            continue;
                                        }

                                        // PDF
                                        if (item.tip === "pdf" && item.url) {
                                            elementi.push(
                                                <a
                                                    key={i}
                                                    href={item.url} // Cloudinary URL z fl_attachment
                                                    download
                                                    className="pdf-gumb"
                                                    rel="noopener noreferrer"
                                                >
                                                    <FaFilePdf style={{ marginRight: "6px" }} /> Prenesi PDF
                                                </a>
                                            );
                                            continue;
                                        }



                                        // LINK
                                        if (item.tip === "link") {
                                            elementi.push(
                                                <a
                                                    key={i}
                                                    href={item.url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="sekcija-link"
                                                >
                                                    {item.naslov || item.url}
                                                    <FaExternalLinkAlt style={{ marginLeft: "6px" }} />
                                                </a>
                                            );
                                            continue;
                                        }
                                    }
                                    return elementi;
                                })()}
                            </div>
                        ))
                    ) : (
                        <p>Ni sekcij v tej novici.</p>
                    )}
                </div>
            </div>





        </div>
    );
};

export default StranNovice;
